import _taggedTemplateLiteral from "/app/vetiver/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";

var _ = function _(t) {
  return t;
},
    _t;

import * as React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { unstable_extendSxProp as extendSxProp } from '@material-ui/system';
import styled from '../styles/experimentalStyled';
var BoxInner =
/*#__PURE__*/
React.forwardRef(function (props, ref) {
  var children = props.children,
      clone = props.clone,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'div' : _props$component,
      other = _objectWithoutPropertiesLoose(props, ["children", "clone", "className", "component", "sx"]);

  if (clone) {
    return (
      /*#__PURE__*/
      React.cloneElement(children, _extends({
        className: clsx(children.props.className, className)
      }, other))
    );
  }

  if (typeof children === 'function') {
    return children(_extends({
      className: className
    }, other));
  }

  return (
    /*#__PURE__*/
    React.createElement(Component, _extends({
      ref: ref,
      className: className
    }, other), children)
  );
});
process.env.NODE_ENV !== "production" ? BoxInner.propTypes = {
  children: PropTypes
  /* @typescript-to-proptypes-ignore */
  .oneOfType([PropTypes.node, PropTypes.func]),
  className: PropTypes.string,
  clone: PropTypes.bool,
  component: PropTypes.elementType,
  sx: PropTypes.object
} : void 0;
var BoxRoot = styled(BoxInner, {}, {
  muiName: 'MuiBox',
  skipVariantsResolver: true
})(_t || (_t = _(_templateObject())));
/**
 * @ignore - do not document.
 */

var Box =
/*#__PURE__*/
React.forwardRef(function Box(inProps, ref) {
  var props = extendSxProp(inProps);
  return (
    /*#__PURE__*/
    React.createElement(BoxRoot, _extends({
      ref: ref
    }, props))
  );
});
process.env.NODE_ENV !== "production" ? Box.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * @ignore
   */
  children: PropTypes
  /* @typescript-to-proptypes-ignore */
  .oneOfType([PropTypes.node, PropTypes.func]),

  /**
   * @ignore
   */
  clone: PropTypes.bool,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,

  /**
   * @ignore
   */
  sx: PropTypes.object
} : void 0;
export default Box;